(function(){
    angular
        .module('appback')
        .directive('ngMielograma124', mielograma124);

        mielograma124.$inject = ['ResultadosService','$timeout'];
        function mielograma124(ResultadosService,$timeout){
            return {
	            //require: 'ngModel',
	            templateUrl: '/backend/resultadopeticion/template?name=mielograma124.twig',
		          scope: {
                  //ngModel : '=',
                  item: '=',
                  animal: '=',
                  centro: '='
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	scope.loadingFields = false;
		            	if(!scope.item.resultado){
			            		scope.item.resultado = { extra : { resultado : { test:'1' }}};
		            	}else{
			            	if(!scope.item.resultado.extra){
			            		scope.item.resultado.extra = { resultado : { test:'1' }};
				            }
				        }

				        scope.subanaliticas = [];
                    	scope.loading = true;
		            	ResultadosService.getSubanaliticasByAnalitica(scope.item.analitica_id,scope.animal.especie_id,scope.centro.idioma_code,function(data){
			               console.log(data.subanaliticas);
			               scope.subanaliticas = data.subanaliticas;
                    		scope.loading = false;
                    		scope.sumaMieloide();
							scope.sumaEritroide();
							scope.sumaLinf();
			            });

		            	function format(icon) {
	                        var originalOption = icon.element;
	                          var str = "";
	                          if(typeof $(originalOption).data('icon') != 'undefined'){
	                            str+='<i class="icon alt'+$(originalOption).data('icon')+'"></i> <span>'+icon.text+'</span>';
	                            return $(str+" ");
	                          }else{
	                            return icon.text || icon.value;
	                          }
	                     }

		            	scope.optionsAtributos = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/select2atributos",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'valoresatt'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
	                	scope.optionsSelect2 = { 
		            		ajax: {
		                        url: "/backend/altcrm/content/select2",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            //nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};
	                	scope.optionsTiposMuestra = {
	                		ajax: {
		                        url: "/backend/resultadopeticion/tiposmuestra",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'tipomuestra',
		                            analitica_id:scope.item.analitica.id
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	}
	                	scope.optionsMicroorganismos = { 
		            		ajax: {
		                        url: "/backend/resultadopeticion/select2microorganismo",
		                        dataType: 'json',
		                        delay: 250,
		                        data: function (params) {
		                          return {
		                            q: params.term, // search term
		                            page: params.page,
		                            field: 'nombre',
		                            per_page: 20,
		                            nodetype:'microorganismo'
		                          };
		                        },
		                        processResults: function (data, params) {
		                          params.page = params.page || 1;
		                          return {
		                            results: data.items,
		                            pagination: {
		                              more: (params.page * 1) < data.total_count
		                            }
		                          };
		                        },
		                        cache: true
		                    },
		                    templateSelection: format,
		                    templateResult: format
	                	};

	                	scope.porcentajeCalc = function(){
	                		var sumatotal = parseFloat(scope.item.resultado.extra.resultado.suma_mieloide) + parseFloat(scope.item.resultado.extra.resultado.suma_eritroide) + parseFloat(scope.item.resultado.extra.resultado.suma_linf);
	                		for(var cont=0;cont<scope.subanaliticas.length;cont++){
		                		//console.log(parseFloat((scope.item.resultado.extra.resultado.subanalitica[subanalitica.codigo_alfa].resultado * 100) / sumatotal).toFixed(2));
		                		if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])!='undefined' && scope.subanaliticas[cont].codigo_alfa!='IME'){
			                		scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].porcentaje = parseFloat((scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado * 100) / sumatotal).toFixed(2);
			                	}
			                }
		                }

	                	scope.sumaMI = function(){
	                		//console.log("sumaMI",scope.item.resultado.extra.resultado.subanalitica);
	                		var resultadoVal = parseFloat(scope.item.resultado.extra.resultado.suma_mieloide / scope.item.resultado.extra.resultado.suma_eritroide).toFixed(2);
	                		if(typeof(scope.item.resultado.extra.resultado.subanalitica['IME'])=='undefined'){
	                			scope.item.resultado.extra.resultado.subanalitica['IME'] = { resultado : '', porcentaje : '' };
	                		}
	                		scope.item.resultado.extra.resultado.subanalitica['IME'].resultado = resultadoVal;
	                		scope.item.resultado.extra.resultado.subanalitica['IME'].porcentaje = resultadoVal;
	                		scope.item.resultado.extra.resultado.indice_me = resultadoVal;
	                		//console.log("ime",scope.item.resultado.extra.resultado.subanalitica);
	                	}

	                	scope.sumaMieloide = function(){
	                		var suma = 0;
	                		//console.log("sima miel");
	                		for(var cont = 0;cont<scope.subanaliticas.length;cont++){
	                			if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])!='undefined' && scope.subanaliticas[cont].bloque==1 && !isNaN(parseFloat(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado))){
									suma += parseInt(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado);
	                			}
	                		}
	                		scope.item.resultado.extra.resultado.suma_mieloide = suma;
	                		scope.sumaMI();
	                	}

	                	scope.sumaEritroide = function(){
	                		var suma = 0;
	                		for(var cont = 0;cont<scope.subanaliticas.length;cont++){
	                			if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])!='undefined' && scope.subanaliticas[cont].bloque==2 && !isNaN(parseFloat(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado))){
									suma += parseInt(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado);
	                			}
	                		}
	                		scope.item.resultado.extra.resultado.suma_eritroide = suma;
	                		scope.sumaMI();
	                	}
	                	scope.sumaLinf = function(){
	                		var suma = 0;
	                		for(var cont = 0;cont<scope.subanaliticas.length;cont++){
	                			if(typeof(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa])!='undefined' && scope.subanaliticas[cont].bloque==3 && !isNaN(parseFloat(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado))){
									suma += parseInt(scope.item.resultado.extra.resultado.subanalitica[scope.subanaliticas[cont].codigo_alfa].resultado);
	                			}
	                		}
	                		scope.item.resultado.extra.resultado.suma_linf = suma;
	                		scope.sumaMI();
	                	}

	                	scope.comprobarDiag = function(){
	                		console.log("comprobar");
	                     	if(scope.item.resultado.extra.resultado.tejido && scope.item.resultado.extra.resultado.diagnostico){
	                     		//COMPROBAMOS SI TENEMOS QUE RELLENAR
	                     		ResultadosService.getDiagnosticoMielPlantilla(scope.item.resultado.extra.resultado.tejido,scope.item.resultado.extra.resultado.diagnostico,scope.centro.idioma_code,function(data){
	                     			if(data.plantilla){
	                     				scope.item.resultado.extra.resultado = angular.merge(scope.item.resultado.extra.resultado, data.plantilla);
	                     				scope.loadingFields = true;

	                     				$timeout(function(){

	                     				scope.loadingFields = false;
	                     				})
	                     			}
	                     			console.log(data);
					               //scope.subanaliticas = data.subanaliticas;
					            });

	                     	}
	                     }
			        });

					
		        }
          }
      }
})();